import React, {useEffect, useState} from 'react'
import Container from '@mui/material/Container'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid';

import FileUpload from '../common/FileUpload';
import FormFooter from '../common/FormFooter';
import Spinner from '../common/Spinner';

import useScrollTop from '../../hooks/useScrollTop';
import {useDataProviderState, useDataProviderActions} from '../../providers/DataProvider';
import {postIdFrontFile, postIdBackFile, postSalaryFile, postProofAddressFile} from '../../api/api';
import HighlightBox from "../common/HighlightBox.jsx";
import {TrackGoogleAnalyticsEvent} from "../../google-analytics/gaTracker.js";

export default function IdFilesUploadStep() {

    const {loading, userData} = useDataProviderState();
    const {nextStep} = useDataProviderActions();

    const [uploadedFilesCount, setUploadedFilesCount] = useState(0);

    useScrollTop();

    TrackGoogleAnalyticsEvent("IdFilesUploadStep");

    return (
        <Container component="section" maxWidth="sm">
            <Box sx={{pb: 2}}>
                <HighlightBox>
                    <Box sx={{display: 'flex'}}>
                        <Box sx={{py: 2}}>
                            <Box className="color-primary" sx={{pl: 3, pr: 3, pb: 1, fontSize: '1.3rem'}}>
                                <b>{userData.nombre},</b>
                            </Box>
                            <Box as="span" sx={{
                                display: 'inline-block',
                                px: 2,
                                color: 'white',
                                background: 'var(--color-primary)',
                                borderBottomRightRadius: '15px',
                                borderTopRightRadius: '15px',
                                fontSize: '1.2rem'
                            }}>
                                ¡Llegamos al último paso!
                            </Box>
                            <Box sx={{p: 1, pl: 2}}>
                                <b className="msg">En pocos minutos podrás retirar tu préstamo en Abitab o Redpagos.</b>
                            </Box>
                        </Box>
                    </Box>
                </HighlightBox>
            </Box>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} sx={{pb: 0}} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12} sx={{pb: 0}}>
                        <ul className="checklist checklist_no_padding">
                            <li className="checklist__title">Necesitamos que nos envies fotos de los siguientes documentos:</li>
                            {/*<li className="checklist__item">Cédula de identidad de frente</li>*/}
                            {/*<li className="checklist__item">Cédula de identidad de contra frente o dorso</li>*/}
                            {/*<li className="checklist__item">Último recibo de sueldo</li>*/}
                            {/*<li className="checklist__item">Constancia de domicilio <small>(puede ser un recibo de UTE, ANTEL, OSE o cualquier otro. Lo importante es que debe estar a tu nombre)</small></li>*/}
                        </ul>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12}>
                        <FileUpload
                            label="Cédula de identidad de frente"
                            upload={postIdFrontFile}
                            onUploadSuccess={() => setUploadedFilesCount(uploadedFilesCount + 1)}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12}>
                        <FileUpload
                            label="Cédula de identidad de dorso"
                            upload={postIdBackFile}
                            onUploadSuccess={() => setUploadedFilesCount(uploadedFilesCount + 1)}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12}>
                        <FileUpload
                            label="Último recibo de sueldo"
                            upload={postSalaryFile}
                            onUploadSuccess={() => setUploadedFilesCount(uploadedFilesCount + 1)}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <Grid container spacing={{xs: 0, sm: 2, pb: 0}} alignItems="center" justifyContent="center">
                <Grid item sm={10} xs={12} alignItems="center" justifyContent="center">
                    <Grid item sm={12} xs={12}>
                        <FileUpload
                            label="Constancia de domicilio"
                            upload={postProofAddressFile}
                            onUploadSuccess={() => setUploadedFilesCount(uploadedFilesCount + 1)}
                        />
                    </Grid>
                </Grid>
            </Grid>

            <FormFooter
                hideBackButton
                onNext={nextStep}
                nextButtonDisabled={uploadedFilesCount < 4}
                nextButtonLabel="finalizar"
            />

            <Spinner loading={loading}/>

        </Container>
    )

}
